import * as React from 'react';

import { PropertyAmenityDescription } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const AmenityDescriptionWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <RefTarget name="Amenities">
      <SimpleLazyLoadWrapper>
        <PropertyAmenityDescription inputs={inputs} />
      </SimpleLazyLoadWrapper>
    </RefTarget>
  </UitkSpacing>
);

export const SharedUiAmenityDescriptionWrapper = withSharedUiPropertyDetails(AmenityDescriptionWrapper);
SharedUiAmenityDescriptionWrapper.displayName = 'SharedUiAmenityDescriptionWrapper';
